
/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'
import { AuthenticationRequest } from '@/types/api'

export default Vue.extend({
  name: 'LoginCallBack',
  created () {
    this.$store.commit('isLoading', true)
    this.$store.commit('isLoadingForce', true)
    this.$store.dispatch('clearLogin')
    const params: AuthenticationRequest = {
      companyId: process.env.VUE_APP_COMPANY_ID,
      state: this.$route.query.state as string,
      code: this.$route.query.code as string
    }
    this.$store.dispatch('login', params).then(toPath => {
      this.$store.commit('isLoading', false)
      this.$store.commit('isLoadingForce', false)
      this.$router.push(toPath)
    })
  }
})
